import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const ExternalLinkIcon = ({
  stroke,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.84512 5.24512H5.74512C4.64055 5.24512 3.74512 6.14055 3.74512 7.24512V18.2451C3.74512 19.3497 4.64055 20.2451 5.74512 20.2451H16.7451C17.8497 20.2451 18.7451 19.3497 18.7451 18.2451V15.1451"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
      <path
        d="M19.7951 10.8912L19.7951 4.64514C19.7951 4.39661 19.5936 4.19514 19.3451 4.19514L13.0991 4.19513M12.5 11.4902L19.3287 4.66158"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};
